import { Fragment } from "react";
import { useLocation } from "react-router-dom";

/**
 * Renders its page anew on every arrival, including a link to the page already on screen (#218
 * review).
 *
 * Following a link to the URL already shown gives the location a new key but keeps the routed
 * component, so a page that loads and marks its data when it mounts did nothing at all. The bell's
 * entries and "View all notifications" link to the Notifications page, and clicked from that page
 * they left its list, the read marker and the badge as they were. Keyed on the location, the page
 * and its TopNavbar mount again, exactly as on a first visit.
 *
 * Only for a page that keeps nothing worth losing: its local state (the page number, a form) starts
 * over on every arrival, and a navigate() to its own URL - a replace included - remounts it as well.
 *
 * @param {{children: JSX.Element}} props The routed page.
 * @returns {JSX.Element}
 */
const RemountOnNavigate = ({ children }) => {
  const location = useLocation();
  return <Fragment key={location.key}>{children}</Fragment>;
};

export default RemountOnNavigate;
